<template>
  <h2
    class="text-2xl xs:text-3xl xs:text-[32px] md:text-4xl lg:text-5xl xl:text-6xl xl:text-[56px]"
  >
    <slot />
  </h2>
</template>
